export default "__VITE_ASSET__485a2626__"